<template>
<ul class="label-switch">
  <li
    v-for="option in options"
    :key="option.value"
    :class="{
      active: option.value === value
    }"
    @click="onclick(option)"
  >{{option.label}}</li>
</ul>
</template>

<script>
export default {
  name: 'LabelSwitch',
  props: {
    value: {
      required: true
    },
    options: {
      required: true,
      type: Array
    }
  },
  methods: {
    onclick (option) {
      const {value} = option

      if (value === this.value) {
        return
      }

      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss">
.label-switch {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 2px;
  margin: 0;
  padding: 0;

  > li {
    padding: 0 5px;
    border: 1px solid transparent {
      radius: 3px;
    };
    color: #409eff;
    user-select: none;
    cursor: pointer;

    &:hover {
      border-color: #b3d8ff;
      background-color: #ecf5ff;
    }

    &.active {
      color: #ffffff;
      background-color: #409eff;
      cursor: default;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LabelSwitch/index.vue